<template>
  <div class="col-12 align-items-center">
    <table style="min-width: 30vw" class="border">
      <thead>
        <tr>
          <th>Count</th>
        <th>Name</th>
        <th>Exposure</th>
        <th>Jail Credit</th>
        <th>Prison Credit</th>
        <!-- <th>Expected Sentence</th> -->
        </tr>
        
      </thead>
      <tbody>
        <tr v-if="strikes">
          <td>0</td>
          <td>Prior Strikes</td>
          <td>0</td>
          <td>20%</td>
          <td>20%</td>
        </tr>
        <tr v-for="chg in convictedCharges" :key="chg.Id">
          <td>{{ chg.CountNumber }}</td>
          <td>{{ chg.codeDefinitionCode }} {{ chg.statuteDefinitionSection }}</td>
          <td v-if="!chg?.newExposureObject?.specialIndeterminate">
            {{
              chg.newExposureObject?.determinate
                ? parseDays(false, chg.newExposureObject.determinate)
                : ""
            }}
            {{
              chg.newExposureObject?.determinate && chg.newExposureObject?.indeterminate
                ? " + "
                : ""
            }}
            {{
              chg.newExposureObject?.indeterminate
                ? parseDays(false, chg.newExposureObject?.indeterminate) !== "LWOP"
                  ? parseDays(false, chg.newExposureObject?.indeterminate) + "-L"
                  : "LWOP"
                : ""
            }}
          </td>
          <td v-else>{{ chg.newExposureObject.specialIndeterminate }}</td>
          <td>{{ parseInt(chg.JailCreditPercentageName)  }}%</td>
          <td>{{ parseInt(chg.PrisonCreditPercentageName) }}%</td>
          <!-- <td v-if="chg.pcredit !=  0">{{parseDays(false, chg.newExposureObject?.expectedSentence)}}  {{chg.newExposureObject?.indeterminate?parseDays(false, chg.newExposureObject?.indeterminate) !== 'LWOP'?parseDays(false, chg.newExposureObject?.indeterminate)  + '-L':'LWOP':''}}</td>
                    <td v-else> {{ chg.newExposureObject?.determinate?parseDays(false, chg.newExposureObject.determinate):''}}
                        {{(chg.newExposureObject?.determinate && chg.newExposureObject?.indeterminate)?' + ':''}}
                        {{chg.newExposureObject?.indeterminate?parseDays(false, chg.newExposureObject?.indeterminate) !== 'LWOP'?parseDays(false, chg.newExposureObject?.indeterminate)  + '-L':'LWOP':''}}
                    </td> -->
        </tr>
      </tbody>
      <!-- <tfoot>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Total Expected Sentence</td>
                <td>{{ Math.floor(totalExpectedSentence) }} days</td>
            </tfoot> -->
    </table>
  </div>
</template>
<script>
import SC from "../../components/utils/sharedComponent.vue";
export default {
  name: "CreditsTable",
  props: ["charges", "totalExpectedSentence"],
  components: { SC },
  data() {
    return {
      convictedCharges: [],
      strikes: false,
    };
  },
  methods: {
    parseDays(truefalse, total_ind) {
      return SC.parseDays(truefalse, total_ind).exp;
    },
  },
  mounted() {
    // console.log(this.charges);
    this.charges.forEach((chg) => {
      if (chg.ChargeStatus == 0) {
        this.convictedCharges.push(chg);
        if (chg.NumberOfStrikes != "0") {
          this.strikes = true;
        }
      }
    });
  },
};
</script>
<style scoped>

th,
td {
  text-align: center !important;
  padding: 0.5rem !important;
}
</style>
